export default "__VITE_ASSET__BQnKHRp9__"